import { TableName } from '@sib/api';
import { Button, DataTable, TableWrapper, useTableSettings } from '@sib/ui';
import { NoTableData } from '@spendbrain/common';
import { useDialogStore } from '@spendbrain/common/stores';
import { useTablePreferencesSettings } from '@spendbrain/hooks';
import { NoVendorsIcon } from '@spendbrain/icons';
import { useAppTranslation } from '@spendbrain/modules/vendors/hooks';
import { ContractDto, mockContracts } from './ContractsTable.utils';
import { useContractsColumns } from './ContractsTable.utils';

export const ContractsTable = () => {
  const { t } = useAppTranslation();
  const { close } = useDialogStore();

  const { onColumnVisibilityChange, state } = useTablePreferencesSettings(
    TableName.Contracts
  );
  const columns = useContractsColumns();

  const tableSettings = useTableSettings<ContractDto>({
    sorting: true,
    ...state,
    onColumnVisibilityChange,
  });

  return (
    <>
      <TableWrapper className="flex-col items-center gap-2">
        <DataTable
          tablePaginationProps={{
            itemsPerPageLabel: t('components.tablePagination.itemsPerPage'),
          }}
          loading={false}
          columns={columns}
          rowCount={mockContracts.length}
          data={mockContracts}
          settings={tableSettings}
          preserveSelectedValues
          noResultsPlaceholder={
            tableSettings.hasFiltersSet ? (
              <NoTableData
                title={t('components.contracts.noFilteredData.title')}
                description={t(
                  'components.contracts.noFilteredData.description'
                )}
              />
            ) : (
              <NoTableData
                title={t('components.contracts.noData.title')}
                description={t('components.contracts.noData.description')}
                Icon={NoVendorsIcon} //TODO: Ask designers for proper icon
              />
            )
          }
        />
      </TableWrapper>
      <Button onClick={close} variant="outline" className="mx-auto mt-2 w-16">
        {t('close')}
      </Button>
    </>
  );
};
